import { Expose } from "class-transformer";
import { EmployeeDocumentUploadModeEnum } from "./employee-document-upload-mode.enum";

export class UpdateEmployeeDocumentCategoryDto {
  @Expose()
  name?: string;

  @Expose()
  key?: string | null;

  @Expose()
  isRequestedByDefault?: boolean;

  @Expose()
  uploadMode?: EmployeeDocumentUploadModeEnum;

  @Expose()
  roleIds?: string[];
}
